import { useCallback, useMemo } from 'react';

import agent from '@root/agent';
// import { makeEnvironmentTagsKey } from '@root/query/environment-tags';
import { SET_SELECTED_ENVIRONMENTS, SET_SELECTED_ENVIRONMENT_TAGS } from '@root/constants/actionTypes';
import { useDispatch, useSelector } from 'react-redux';
// import _ from 'lodash';
// import useEnhancedQuery from '@root/query/useEnhancedQuery';
// let token = null;

import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
// import { isEmpty } from 'lodash';

// Mock AWS account disabled — environments come from the API only.
// export const MOCK_AWS_ACCOUNT = {
//   cloud_provider: 'aws',
//   id: '782681689401',
//   environment_name: 'AWS Accounts',
//   tags: [
//     {
//       name: 'Testing',
//       type: 'primary',
//     },
//   ],
//   latest_scan_id: '782681689401',
//   identity_scan_id: '782681689401',
//   eks_enable: true,
// };

// export const attachMockEnvironment = data => {
//   if (!data) {
//     return { data: [MOCK_AWS_ACCOUNT] };
//   }
//
//   if (Array.isArray(data)) {
//     const exists = data.some(item => String(item?.id) === String(MOCK_AWS_ACCOUNT.id));
//     return exists ? data : [...data, MOCK_AWS_ACCOUNT];
//   }
//
//   const rawList = Array.isArray(data?.data) ? data.data : [];
//   const exists = rawList.some(item => String(item?.id) === String(MOCK_AWS_ACCOUNT.id));
//   return {
//     ...data,
//     data: exists ? rawList : [...rawList, MOCK_AWS_ACCOUNT],
//   };
// };

const fetchEnvironments = async () => {
  const tenantName = localStorage.getItem('tenantName');
  const uniqueUserId = localStorage.getItem('uniqueUserId');
  const cacheKey = `environments_${uniqueUserId}_${tenantName}`;

  const cachedData = localStorage.getItem(cacheKey);

  if (cachedData && !isEmpty(JSON.parse(cachedData))) {
    try {
      return JSON.parse(cachedData);
    } catch (e) {
      console.error('Failed to parse cached environments:', e);
    }
  }

  try {
    const res = await agent.Environment.fetch_environments_and_cloud_providers();
    localStorage.setItem(cacheKey, JSON.stringify(res));
    return res;
  } catch (error) {
    console.error('Failed to fetch environments:', error);
    try {
      const fallback = localStorage.getItem(cacheKey);
      return fallback ? JSON.parse(fallback) : { data: [] };
    } catch {
      return { data: [] };
    }
  }
};

const useEnvironmentsData = () => {
  const { data, isLoading, error } = useQuery(['fetchglobalfilter'], fetchEnvironments, {
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  return {
    data,
    isLoading,
    error,
  };
};

const useEnvironmentTags = () => {
  const { data } = useEnvironmentsData();

  const environmentTags = useMemo(() => {
    if (!data || !data.data || !data.data.length) return [];

    let tags = [];

    for (const env of data.data) {
      for (const tag of env.tags) {
        if (tag.type === 'primary') {
          tags.push(tag.name);
        }
      }
    }

    tags = tags.reduce((prev, curr) => (prev.includes(curr) ? prev : [...prev, curr]), []).filter(tag => tag);

    return ['Global', ...tags];
  }, [data]);

  return environmentTags;
};

const useEnvironments = () => {
  const { data } = useEnvironmentsData();
  // console.log(data,'vchdvdh')

  const environments = useMemo(() => {
    if (!data || !data.data || !data.data.length) return [];

    let _environments = [];

    for (const env of data.data) {
      _environments.push({
        id: env.id,
        tags: env.tags.map(t => t.name),
        cloudProvider: env.cloud_provider,
        environment_name: env.environment_name,
      });
    }

    return _environments;
  }, [data]);

  return environments;
};

const useSelectedEnvironments = () => {
  const dispatch = useDispatch();

  const { selectedEnvironmentTags, selectedEnvironments } = useSelector(store => {
    return store.environments;
  });

  const setSelectedEnvironmentTags = useCallback(
    tags => {
      if (typeof tags === 'function') {
        // We treat this the same way as passing a callback to setState
        dispatch({ type: SET_SELECTED_ENVIRONMENT_TAGS, payload: tags(selectedEnvironmentTags) });
      } else {
        dispatch({ type: SET_SELECTED_ENVIRONMENT_TAGS, payload: tags });
      }
    },
    [dispatch, selectedEnvironmentTags],
  );

  const setSelectedEnvironments = useCallback(
    envs => {
      if (typeof envs === 'function') {
        // We treat this the same way as passing a callback to setState
        dispatch({ type: SET_SELECTED_ENVIRONMENTS, payload: envs(selectedEnvironments) });
      } else {
        dispatch({ type: SET_SELECTED_ENVIRONMENTS, payload: envs });
      }
    },
    [dispatch, selectedEnvironments],
  );

  return { selectedEnvironmentTags, selectedEnvironments, setSelectedEnvironmentTags, setSelectedEnvironments };
};

export { useEnvironmentTags, useEnvironments, useEnvironmentsData, useSelectedEnvironments };
// export default {
//   setToken: _token => {
//     token = _token;
//   },
// };
